import type { SiteNavigationProps, LinkProps, LabelProps } from '../../../components/siteNavigation/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';
const siteNavigationTransformer = (data: CMSTransformerDataType): SiteNavigationProps => {
  const { links = [], right_section = {} } = data || {};

  const leftSectionData: LinkProps[] = links.map((link: CMSTransformerDataType) => ({
    title: link.text,
    href: link.url,
    target: link?.target,
  }));

  const rightSectionData: LabelProps[] = [];
  Object.keys(right_section).forEach((item) => {
    if (typeof right_section[item] === 'string') {
      const data = {
        label: right_section[item],
      };
      rightSectionData.push(data);
    }
  });

  return {
    linkData: {
      leftSection: leftSectionData,
      rightSection: rightSectionData,
    },
    componentType: 'top_navigation',
  };
};

export default siteNavigationTransformer;
